/**
 * Data Explorer Service
 * API Service that reads from Elasticsearch.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import FacetsResponse from '../model/FacetsResponse';

/**
* Facets service.
* @module api/FacetsApi
* @version 0.0.1
*/
export default class FacetsApi {

    /**
    * Constructs a new FacetsApi. 
    * @alias module:api/FacetsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the facetsGet operation.
     * @callback module:api/FacetsApi~facetsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FacetsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns facets.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.filter filter represents selected facet values. Elasticsearch query will be run only over selected facet values. filter is an array of strings, where each string has the format \&quot;esFieldName&#x3D;facetValue\&quot;. Example url /facets?filter&#x3D;Gender&#x3D;female,Region&#x3D;northwest,Region&#x3D;southwest 
     * @param {Array.<String>} opts.extraFacets extraFacets represents the fields selected from the field search box. extraFacets is a list of Elasticsearch field names. In the returned list of facets, the extra facets will come before the facets from ui.json.
     * @param {module:api/FacetsApi~facetsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FacetsResponse}
     */
    facetsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
        'filter': this.apiClient.buildCollectionParam(opts['filter'], 'pipes'),
        'extraFacets': this.apiClient.buildCollectionParam(opts['extraFacets'], 'pipes')
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = FacetsResponse;

      return this.apiClient.callApi(
        '/facets', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }


}
